import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Session } from '../../services/session/session.service';

@Injectable()
export class GlobalAdminGuard implements CanActivate {

    constructor(
      private router: Router,
      private session: Session
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.session.currentUser && this.session.currentUser.nivelPrivilegios == 100) {
            // logged in so return true

            return true;
        }

        if(sessionStorage.getItem('id_token') && sessionStorage.getItem('access_token') && sessionStorage.getItem('currentUser')){
            this.session.setIdToken(sessionStorage.getItem('id_token'));
            this.session.setAccessToken(sessionStorage.getItem('access_token'));
            this.session.setCurrentUser(JSON.parse(sessionStorage.getItem('currentUser')));

            if(this.session.currentUser.nivelPrivilegios == 100){
              return true;
            }
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/configurar']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/guards/globaladmin/globaladmin.guard.ts